import classNames from 'classnames';
import styled from 'styled-components';

const MainWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 38px;

  .bl-steps-wrap {
    width: 202px;
    display: flex;
    justify-content: space-between;

    .step {
      color: white;
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #bbbbbb;
      font-weight: 400;
      font-size: 32px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 50%;
      z-index: 2;

      &.active {
        background-color: #4b4b4b;
      }

      &.done {
        background-color: #ea475c;
      }
    }
  }

  hr {
    position: absolute;
    top: 10px;
    width: 172px;
    border: 1px solid #8e8e8e;
    z-index: 1;
  }
`;
const StepsBlock = (props: { count: number; active: number; done?: number[] }) => {
  const { count, active, done = [] } = props;
  let steps = [];
  for (let i = 0; i < count; i++)
    steps.push(
      <div
        key={i}
        className={classNames('step', active === i + 1 && 'active', done.includes(i + 1) && 'done')}
      >
        {done.includes(i + 1) ? <i className="fas fa-check" /> : i + 1}
      </div>,
    );
  return (
    <MainWrap className="bl-steps-widget">
      <div className="bl-steps-wrap">{steps}</div>
      <hr />
    </MainWrap>
  );
};

export default StepsBlock;
